import Vue from 'vue';
import path from 'path';
// import { get } from '@/api';

Vue.mixin({
    data() {
        return {
            systemName: '健康及保險知識+',
            size: 12,
            // menuList: [
            //     {
            //         imgUrl: require('@/assets/images/menuIcons/list_01.svg'),
            //         imgActiveUrl: require('@/assets/images/menuIcons/list_01_white.svg'),
            //         alt: '所有內容',
            //         label: '所有內容',
            //         value: '',
            //         children: [],
            //     },
            //     {
            //         imgUrl: require('@/assets/images/menuIcons/list_02.svg'),
            //         imgActiveUrl: require('@/assets/images/menuIcons/list_02_white.svg'),
            //         alt: '旅遊',
            //         label: '旅遊',
            //         value: '旅遊',
            //         children: [
            //             { label: '旅人味', value: '旅人味' },
            //             { label: '閱讀旅行', value: '閱讀旅行' },
            //         ],
            //     },
            //     {
            //         imgUrl: require('@/assets/images/menuIcons/list_03.svg'),
            //         imgActiveUrl: require('@/assets/images/menuIcons/list_03_white.svg'),
            //         alt: '生活',
            //         label: '生活',
            //         value: '生活',
            //         children: [
            //             { label: '節慶生活', value: '節慶生活' },
            //             { label: '生活新知', value: '生活新知' },
            //             { label: '趣味人生', value: '趣味人生' },
            //             { label: '家庭情感', value: '家庭情感' },
            //         ],
            //     },
            //     {
            //         imgUrl: require('@/assets/images/menuIcons/list_04.svg'),
            //         imgActiveUrl: require('@/assets/images/menuIcons/list_04_white.svg'),
            //         alt: '理財',
            //         label: '理財',
            //         value: '理財',
            //         children: [
            //             { label: '投資運用', value: '投資運用' },
            //             { label: '養老退休', value: '養老退休' },
            //             { label: '理財規劃', value: '理財規劃' },
            //         ],
            //     },
            //     {
            //         imgUrl: require('@/assets/images/menuIcons/list_05.svg'),
            //         imgActiveUrl: require('@/assets/images/menuIcons/list_05_white.svg'),
            //         alt: '保險',
            //         label: '保險',
            //         value: '保險',
            //         children: [
            //             { label: '保險趣味', value: '保險趣味' },
            //             { label: '人身保障', value: '人身保障' },
            //             { label: '保險資訊', value: '保險資訊' },
            //         ],
            //     },
            //     {
            //         imgUrl: require('@/assets/images/menuIcons/list_06.svg'),
            //         imgActiveUrl: require('@/assets/images/menuIcons/list_06_white.svg'),
            //         alt: '健康',
            //         label: '健康',
            //         value: '健康',
            //         children: [
            //             { label: '疾病預防', value: '疾病預防' },
            //             { label: '癌症', value: '癌症' },
            //             { label: '心血管疾病', value: '心血管疾病' },
            //             { label: '健康飲食', value: '健康飲食' },
            //             { label: '健康新知', value: '健康新知' },
            //             { label: '樂齡議題', value: '樂齡議題' },
            //             { label: '運動', value: '運動' },
            //             { label: '心靈健康', value: '心靈健康' },
            //         ],
            //     },
            //     {
            //         imgUrl: require('@/assets/images/menuIcons/list_06.svg'),
            //         imgActiveUrl: require('@/assets/images/menuIcons/list_06_white.svg'),
            //         alt: '健康與運動',
            //         label: '健康與運動',
            //         value: '健康與運動',
            //         children: [
            //             { label: '運動議題', value: '運動議題' },
            //             { label: '醫療疾病', value: '醫療疾病' },
            //             { label: '樂活議題', value: '樂活議題' },
            //         ],
            //     },
            //     {
            //         imgUrl: require('@/assets/images/menuIcons/list_07.svg'),
            //         imgActiveUrl: require('@/assets/images/menuIcons/list_07_white.svg'),
            //         alt: '特色內容',
            //         label: '特色內容',
            //         value: '特色內容',
            //         children: [],

            //     },
            // ],
        };
    },
    methods: {
        delay(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
        getResourcePath(filename) {
            return path.join(
                process.env.VUE_APP_CONTEXT_PATH,
                process.env.VUE_APP_RESOURCE_PATH,
                filename
            );
        },
        getImagePath(filename) {
            return path.join(
                process.env.VUE_APP_CONTEXT_PATH,
                process.env.VUE_APP_IMAGE_PATH,
                filename === undefined ? '' : filename
            );
        },
        previewImage(filename) {
            if (!filename) {
                return require('@/assets/images/home/img_nopicture.jpg');
            }
            return this.getImagePath(filename);
        },
        setDisplayArticles(type) {
            this.display = type;
            this.$store.dispatch('setDisplayArticles', type);
        },
        go404Page(status) {
            this.$router.push({ name: 'error', params: { errorCode: status || 404 } }).catch(() => { });
        },
    },
});
